<template>
  <div class="loginPage">
    <div class="background"></div>
    <div class="loginBox">
      <div class="logoSection">
        <img class="logo" src="@/assets/phoenixEng.png" alt="Phoenix Engineering">
        <p class="logoText">TRANSPARENT IN DESIGN AND CONSTRUCTION</p>
        <router-link class="link" :to="{ name: 'register' }">{{ t("link") }}</router-link>
      </div>

      <form @submit.prevent="login" class="formLogin">
        <h3>{{ t("continue") }}</h3>
        <div class="inputWrap" id="inpFirst">
          <BaseInput class="baseInput" v-model="userName" :placeholder="t('userName')"/>
        </div>

        <div class="inputWrap" id="inpLast">
          <BaseInput
            class="baseInput"
            v-model="passWord"
            :placeholder="t('passWord')"
            type="password"
          />
        </div>

        <button
          class="btn"
          type="submit"
          :disabled="!userName || !passWord"
          :class="{
            disabledButton: !userName || !passWord,
          }"
        >{{ t("signIn") }}</button>
        <p v-if="error == 'Request failed with status code 400'">{{ t("error") }}</p>
        <p
          v-if="error == 'Request failed with status code 400'"
        >{{ t("forgot") }} phoenix-tests@outlook.com</p>
      </form>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import BaseInput from "@/components/BaseInput";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },
  components: {
    BaseInput
  },
  data() {
    return {
      userName: "",
      passWord: ""
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("loginUser", {
          userName: this.userName,
          passWord: this.passWord
        })
        .then(() => {
          if (!this.error) {
            this.$router.push({ name: "courses" });
          }
        });
    }
  },
  created() {
    this.$store.dispatch("logOut");
  },

  computed: {
    error() {
      return this.$store.state.errorLogin;
    }
  }
};
</script>

<i18n>
{
  "en-GB": {
    "continue":"Sign in to continue.",
    "userName": "Username",
    "passWord": "Password",
    "link":"Don't have an account? Sign up here.",
    "error":"Username or password is incorrect.",
    "forgot":"Forgot your password? Contact",
    "signIn":"Sign in"   
  },
  "nl-NL": {
    "continue":"Log in om door te gaan.",
    "userName": "Gebruikersnaam",
    "passWord": "Wachtwoord",
    "link":"Heb je geen account? Registreer hier.",
    "error":"Gebruikersnaam of wachtwoord is onjuist.",
    "forgot":"Wachtwoord vergeten? Contact",
    "signIn":"Inloggen"
  }
}
</i18n>

<style scoped>
.loginPage {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
}

.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}

.loginBox {
  display: flex;
  margin: auto;

  height: 600px;
  width: 1000px;

  background-color: rgba(221, 221, 221, 0.92);
  box-shadow: 0 32px 64px rgba(235, 235, 235, 0.267);
}

.logoSection {
  position: relative;
  background-color: rgb(62, 62, 62);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;
}
.logo {
  width: 350px;
}

.logoText {
  width: 300px;
  margin: 0px;
}

.formLogin {
  display: flex;
  flex-direction: column;
  width: 60%;
  align-items: center;
}

h3 {
  font-size: 32px;
  margin-top: 80px;
  margin-bottom: 0px;
}

.inputWrap {
  display: flex;
  align-content: center;
  justify-content: center;
}

.baseInput {
  display: inline;
}
.link {
  position: absolute;
  bottom: 0;
  margin-bottom: 30px;
  font-size: 15px;
  text-decoration: none;
  color: gray;
}
.link:hover {
  transform: scale(1.05);
}
#inpFirst {
  margin-top: 130px;
  margin-bottom: 40px;
}
#inpLast {
  margin-bottom: 110px;
}

/* -------------------------------------------------------------------------------------------BTN----------------------------------------------------------------------------- */

.btn {
  font-family: "Raleway", sans-serif;
  letter-spacing: 1px;
  padding: 12px 30px;
  background-color: rgb(62, 62, 62);
  margin-bottom: 20px;

  border-style: none;
  color: rgb(255, 255, 255);

  font-size: 15px;
  cursor: pointer;

  box-shadow: 0 0px 3px 0px rgb(89, 102, 100);
}
.btn:hover {
  transform: scale(1.05);
}
.disabledButton {
  opacity: 0.4;
  cursor: not-allowed;
}
p {
  font-weight: 600;
  color: rgb(216, 23, 23);
  font-size: 14px;
  padding: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

@media screen and (max-width: 1200px) {
  .loginBox {
    height: 500px;
    width: 800px;
  }

  .logo {
    width: 280px;
  }
  .logoText {
    width: 280px;
  }

  h3 {
    font-size: 28px;
    margin-top: 50px;
  }
  .link {
    font-size: 13px;
  }

  #inpFirst {
    margin-top: 100px;
    margin-bottom: 40px;
  }

  #inpLast {
    margin-bottom: 90px;
  }

  p {
    font-size: 13px;
  }
  .btn {
    font-size: 13px;
  }
}

@media screen and (max-width: 1000px) {
  .loginBox {
    height: 400px;
    width: 600px;
  }
  .logo {
    width: 230px;
  }
  .logoText {
    width: 230px;
  }

  h3 {
    font-size: 22px;
    margin-top: 40px;
  }
  .link {
    font-size: 11px;
    margin-bottom: 15px;
  }

  #inpFirst {
    margin-top: 80px;
    margin-bottom: 30px;
  }

  #inpLast {
    margin-bottom: 60px;
  }

  p {
    font-size: 11px;
    margin-top: 4px;
  }
  .btn {
    font-size: 11px;
    padding: 8px 15px;
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 700px) {
  .loginBox {
    flex-direction: column-reverse;
    align-content: center;

    height: 600px;
    width: 400px;
  }
  .logoSection {
    width: 100%;
    height: 40%;
    background-color: initial;
  }

  .formLogin {
    width: 100%;
  }

  h3 {
    font-size: 22px;
    margin-top: 40px;
  }
  .link {
    font-size: 11px;
    margin-bottom: 25px;
    color: black;
    font-weight: 600;
    text-decoration: underline;
  }

  #inpFirst {
    margin-top: 80px;
    margin-bottom: 30px;
  }

  #inpLast {
    margin-bottom: 60px;
  }

  p {
    font-size: 11px;
    margin-top: 4px;
  }
  .btn {
    font-size: 11px;
    padding: 8px 15px;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 500px) {
    .loginBox {
      width: 350px;
    }
  }
  @media screen and (max-width: 390px) {
    .loginBox {
      width: 330px;
    }
  }
  @media screen and (max-width: 300px) {
    .loginBox {
      width: 270px;
    }
  }
}
</style>